module.exports = __webpack_public_path__ + "c3e4c5c7332c42733357332eecd67fa9.svg";